const { NODE_ENV, VUE_APP_VERSION } = process.env;
const extension = NODE_ENV === 'production' ? 'io' : 'be';

module.exports = {
  build: {
    version: VUE_APP_VERSION,
    timestamp: Math.ceil(+new Date() / 1000)
  },
  apiUrl: `https://api.control.rapidaim.${extension}`,
  authUrl: `https://auth.rapidaim.${extension}/client`
};
